import React from "react";

const Arrows = props => {

	const scrollbar = props.scrollbar;

	const arrowClicked = arrow => {
		if (arrow === 'prev') {
			scrollbar.scrollTo(scrollbar.offset.x - 300, 0, 500);
		} else {
			scrollbar.scrollTo(scrollbar.offset.x + 300, 0, 500);
		}
	}

	return (
		<div id="Arrows">
			<button className={`arrow prev-arrow arrow-${props.prevClass}`} onClick={() => arrowClicked('prev')}></button>
			<button className={`arrow next-arrow arrow-${props.nextClass}`} onClick={() => arrowClicked('next')}></button>
		</div>
	)
}

export default Arrows;